export const fuelCategories = ["City", "City & Highway Combined", "Highway"] as const;

export type FuelCategoryType = (typeof fuelCategories)[number];